(() => {
  class MailOrderInfoController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, Orders, Messages, Users, Auth, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        Orders,
        Messages,
        Users,
        Auth,
        $state,
        ngDialog,
        mailordervisit: $scope.ngDialogData.visit,
        messages: [],
        beforeCursor: null,
        afterCursor: null,
        POLL_INTERVAL: 5000
      });
      this.getMailOrderInfo();
    }

    close() {
      this.$scope.closeThisDialog();
    }

    getMailOrderInfo() {
      this.mailInfo;
      var this2 = this;
      this.Orders.getMailOrderHistory(this.mailordervisit.id).then(mailorderdata => {
        console.log(mailorderdata.data);
        this2.mailInfo = mailorderdata.data;
      }).catch(() => {});
    }

  }

  MailOrderInfoController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "Orders", "Messages", "Users", "Auth", "$state", "ngDialog"];
  angular.module('pims').controller('MailOrderInfoController', MailOrderInfoController);
})();